import {
  DateFieldAbsoluteFilter,
  DateFieldFilter,
  DateFieldFilterOperationType,
  DateFieldRelativeFilter,
  RelativeDirection,
} from 'module/types/filter-field/filter/date';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { renderAbsoluteMenuItem } from './absolute-menu-item';
import { isRelative, isBasic, isAbsolute, isOptional } from './helpers';
import { renderMenuItem } from './menu-item';
import { renderRelativeMenuItem } from './relative-menu-item';

const ItemGroup = styled(Menu.ItemGroup)`
  .ant-dropdown-menu-item-group-title {
    text-transform: capitalize;
    opacity: 0.67;
  }
`;

export const renderOverlay = (
  filter: DateFieldFilter,
  onChange: (filter: DateFieldFilter) => void,
  setVisible: (visible: boolean) => void,
  items: DateFieldFilter[],
  onAdvancedClick: () => void,
  _advanced: boolean,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | React.JSX.Element,
) => {
  const basicDates = items.filter((eachFilter) => isBasic(eachFilter.type));
  const relativeDates = items.filter((eachFilter) =>
    isRelative(eachFilter.type),
  );
  const absoluteDates = items.filter((eachFilter) =>
    isAbsolute(eachFilter.type),
  );
  const optionalDates = items.filter((eachFilter) =>
    isOptional(eachFilter.type),
  );

  const advanced =
    filter?.field?.metaData?.showAllOps === true ? true : _advanced;

  return (
    <Menu
      className="date-criteria"
      selectable
      selectedKeys={[filter.type.toString()]}
      onSelect={({ key }) => {
        if (key === 'advanced') {
          window.setTimeout(onAdvancedClick, 30);

          return;
        }
        const type = key as DateFieldFilterOperationType;

        onChange({
          ...filter,
          type,
          days: (filter as DateFieldRelativeFilter).days,
          direction:
            (filter as DateFieldRelativeFilter).direction ??
            RelativeDirection.Ago,
          value: (filter as DateFieldAbsoluteFilter).value,
        } as DateFieldFilter);
        if (!isRelative(type) && !isAbsolute(type)) {
          setVisible(false);
        }
      }}
    >
      {basicDates.length && filter?.field?.metaData?.allowBaseOps !== false ? (
        <>
          {basicDates.map((x) =>
            renderMenuItem(x.type, getOperationOptionRenderer),
          )}
          <Menu.Divider />
        </>
      ) : null}
      {!advanced && (
        <Menu.Item
          data-cy="op.advanced"
          key="advanced"
          className="date-criteria"
        >
          <FormattedMessage id="task_list.filters.advanced" />
        </Menu.Item>
      )}
      {advanced && (
        <>
          {relativeDates.length &&
          filter?.field?.metaData?.allowRelativeDateOps !== false ? (
            <>
              <ItemGroup
                title={<FormattedMessage id="task_list.filters.relative" />}
              >
                {relativeDates.map((x) =>
                  renderRelativeMenuItem(
                    filter,
                    x.type,
                    onChange,
                    getOperationOptionRenderer,
                    filter?.field?.metaData?.filterContext,
                  ),
                )}
              </ItemGroup>
              <Menu.Divider />
            </>
          ) : null}

          {absoluteDates.length &&
          filter?.field?.metaData?.allowAbsDateOps !== false ? (
            <>
              <ItemGroup
                title={<FormattedMessage id="task_list.filters.absolute" />}
              >
                {absoluteDates.map((x) =>
                  renderAbsoluteMenuItem(
                    filter,
                    x.type,
                    onChange,
                    getOperationOptionRenderer,
                  ),
                )}
              </ItemGroup>
              <Menu.Divider />
            </>
          ) : null}

          {!filter.field.metaData?.required && optionalDates.length ? (
            <>
              {optionalDates.map((x) =>
                renderMenuItem(x.type, getOperationOptionRenderer),
              )}
            </>
          ) : null}
        </>
      )}
    </Menu>
  );
};
